import React, { useState } from "react";
import { Row } from "reactstrap";
import { H4, H5, H6, P } from "../../../AbstractElements";
import {
  TaskHeadings1,
  TaskHeadings2,
  TaskHeadings3,
} from "../../../Data/Driver/DriverContent";
import moment from "moment";
import RechargeModal from "../DriverListing/RechargeModal";
const DriverContent = ({ driverObj, walletBalance,totalCollectableAmount,fetchDriverCollections,totalCommissionAmount }) => {
  const [rechargeModal, setRechargeModal] = useState(false);
  const toggleRechargeModal = () =>
    setRechargeModal(!rechargeModal);
  const [isAmountPopulate, setIsAmountPopulate] = useState(false); 
  const Table3Data = TaskHeadings3.map((element, i) => {
    let value = driverObj[element.value] ? driverObj[element.value] : '-'
    if ((element.value == 'createdOn' || element.value == 'deletedOn' || element.value == 'updatedOn') && value !== '-') {
      console.log(value, 'value');
      value = moment(value).format('MMM DD,YYYY')
    }
    if (element.value == 'ratingAvg') {
      console.log(value, 'value');
      value = driverObj[element.value]
    }
    if ((element.value == "blockedReason" || element.value == "blockedBy") && driverObj["isAvailable"]) {
      return;
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  })
  return (
    <Row>
      <div className="table-responsive">
        <table className="driver-list-table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {TaskHeadings1.map((element, i) => {
              return (
                <tr key={i}>
                  <td>
                    <P>{element.name}</P>
                  </td>
                  <td>
                    <P>{driverObj[element.value] ? driverObj[element.value] : '-'}</P>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-responsive">
        <table className="driver-list-table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {TaskHeadings2.map((element, i) => {
              let value = driverObj[element.value] ? driverObj[element.value] : '-'
              if ((element.value == 'createdOn' || element.value == 'deletedOn' || element.value == 'updatedOn') && value !== '-') {
                console.log(value, 'value');
                value = moment(value).format('MMM DD,YYYY')
              }
              return (
                <tr key={i}>
                  <td>
                    <P>{element.name}</P>
                  </td>
                  <td>
                    <P>{value}</P>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-responsive" style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}>
        <table className="driver-list-table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {Table3Data}
          </tbody>
        </table>
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: "10px",
          color: "black"
        }}>
          <span style={{
            margin: "5px 0px"
          }}>Wallet Balance</span>
          <H5>{walletBalance ? walletBalance : "-"}</H5>
        </div>
        {driverObj?.isEvDriver && <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: 10,
          cursor: "pointer",
          color: "black"
        }}
        title="Click to collect"
        onClick={()=>{
          setIsAmountPopulate(true)
          toggleRechargeModal()
        }}
        >
          <span style={{
            margin: "5px 0px"
          }}>Total Collectable Amount</span>
          <H5>{totalCollectableAmount ? totalCollectableAmount : "-"}</H5>
        </div>}
      </div>
      <RechargeModal
        Large={rechargeModal}
        title={"Recharge Driver"}
        LargeModaltoggle={()=>{
          fetchDriverCollections()
          toggleRechargeModal()
        }}
        fetchData={fetchDriverCollections}
        driverObj={driverObj}
        isAmountPopulate={isAmountPopulate}
        populateAmount={totalCollectableAmount ? totalCollectableAmount : 0}
        totalCommissionAmount={totalCommissionAmount ? totalCommissionAmount : 0}
      />
    </Row>
  );
};

export default DriverContent;
